export const GET_ALL_LEADS = "GET_ALL_LEADS"
export const GET_ALL_LEADS_SUCCESS = "GET_ALL_LEADS_SUCCESS"
export const GET_ALL_LEADS_ERROR = "GET_ALL_LEADS_ERROR"

export const DOWNLOAD_LEADS = "DOWNLOAD_LEADS"
export const DOWNLOAD_LEADS_SUCCESS = "DOWNLOAD_LEADS_SUCCESS"
export const DOWNLOAD_LEADS_ERROR = "DOWNLOAD_LEADS_ERROR"
